import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-figma-large.tsx
/**
* icon.24.figma.large
*
* Keywords: figma-logo, branding, f-letter, circles, geometric, design-tool, rounded, abstract
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNi41IDdjMCAxLjA0My41MzMgMS45NjMgMS4zNDEgMi41QTMgMyAwIDAgMCA2LjUgMTJjMCAxLjA0My41MzMgMS45NjMgMS4zNDEgMi41QTMgMyAwIDEgMCAxMi41IDE3di0yLjc2NEEzIDMgMCAxIDAgMTYuMTU5IDkuNSAzIDMgMCAwIDAgMTQuNSA0aC01YTMgMyAwIDAgMC0zIDNtOCAyYTIgMiAwIDEgMCAwLTRoLTJ2NHptLTIgM2EyIDIgMCAxIDAgNCAwIDIgMiAwIDAgMC00IDBtLTEgMmgtMmEyIDIgMCAxIDEgMC00aDJ6bS0yIDFoMnYyYTIgMiAwIDEgMS0yLTJtMi02aC0yYTIgMiAwIDEgMSAwLTRoMnoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-915
*/
const Icon24FigmaLarge = memo(function Icon24FigmaLarge(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M6.5 7c0 1.043.533 1.963 1.341 2.5A3 3 0 0 0 6.5 12c0 1.043.533 1.963 1.341 2.5A3 3 0 1 0 12.5 17v-2.764A3 3 0 1 0 16.159 9.5 3 3 0 0 0 14.5 4h-5a3 3 0 0 0-3 3m8 2a2 2 0 1 0 0-4h-2v4zm-2 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0m-1 2h-2a2 2 0 1 1 0-4h2zm-2 1h2v2a2 2 0 1 1-2-2m2-6h-2a2 2 0 1 1 0-4h2z",
			clipRule: "evenodd"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M7 7c0 1.043.533 1.963 1.341 2.5A3 3 0 0 0 7 12c0 1.043.533 1.963 1.341 2.5A3 3 0 1 0 13 17v-2.764A3 3 0 1 0 16.659 9.5 3 3 0 0 0 15 4h-5a3 3 0 0 0-3 3m8 2a2 2 0 1 0 0-4h-2v4zm-2 3a2 2 0 1 0 4 0 2 2 0 0 0-4 0m-1 2h-2a2 2 0 1 1 0-4h2zm-2 1h2v2a2 2 0 1 1-2-2m2-6h-2a2 2 0 1 1 0-4h2z",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24FigmaLarge };

//# sourceMappingURL=icon-24-figma-large.js.map